import { MappedTranslations } from '@hellodarwin/core/lib/features/entities/translations-entities';
import alertsEn from './en/alerts.json';
import clientTasksEn from './en/client-tasks.json';
import documentJourneyEn from './en/document-journey.json';
import grantAvailabilityEn from './en/grant-availability.json';
import grantCardStatusEn from './en/grant-card-status.json';
import onboardingEn from './en/onboarding.json';
import gamePlanCyclesEn from './en/game-plan-cycles.json';
import projectEn from './en/project.json';
import propulsionEn from './en/propulsion.json';
import programWorkspaceEn from './en/program-workspace.json';
import resourceEn from './en/resource.json';
import rfpEn from './en/rfp.json';
import documentsEn from './en/documents.json';
import alertsFr from './fr/alerts.json';
import clientTasksFr from './fr/client-tasks.json';
import documentJourneyFr from './fr/document-journey.json';
import grantAvailabilityFr from './fr/grant-availability.json';
import grantCardStatusFr from './fr/grant-card-status.json';
import onboardingFr from './fr/onboarding.json';
import gamePlanCyclesFr from './fr/game-plan-cycles.json';
import projectFr from './fr/project.json';
import propulsionFr from './fr/propulsion.json';
import programWorkspaceFr from './fr/program-workspace.json';
import resourceFr from './fr/resource.json';
import rfpFr from './fr/rfp.json';
import documentsFr from './fr/documents.json';
import assetsEn from '../../../content/locales/en/assets.json';
import assistantEn from '../../../content/locales/en/assistant.json';
import commonEn from '../../../content/locales/en/common.json';
import confirmModalEn from '../../../content/locales/en/confirm-modal.json';
import errorsEn from '../../../content/locales/en/errors.json';
import grantsEn from '../../../content/locales/en/grants.json';
import langEn from '../../../content/locales/en/lang.json';
import portfolioEn from '../../../content/locales/en/portfolio.json';
import profileEn from '../../../content/locales/en/profile.json';
import programsEn from '../../../content/locales/en/programs.json';
import projectSingleEn from '../../../content/locales/en/project-single.json';
import providerProfileEn from '../../../content/locales/en/provider-profile.json';
import reviewsEn from '../../../content/locales/en/reviews.json';
import tagsEn from '../../../content/locales/en/tags.json';
import teamEn from '../../../content/locales/en/team.json';
import timeTrackingEn from '../../../content/locales/en/time-tracking.json';
import assetsFr from '../../../content/locales/fr/assets.json';
import assistantFr from '../../../content/locales/fr/assistant.json';
import commonFr from '../../../content/locales/fr/common.json';
import confirmModalFr from '../../../content/locales/fr/confirm-modal.json';
import errorsFr from '../../../content/locales/fr/errors.json';
import grantsFr from '../../../content/locales/fr/grants.json';
import langFr from '../../../content/locales/fr/lang.json';
import portfolioFr from '../../../content/locales/fr/portfolio.json';
import profileFr from '../../../content/locales/fr/profile.json';
import programsFr from '../../../content/locales/fr/programs.json';
import projectSingleFr from '../../../content/locales/fr/project-single.json';
import providerProfileFr from '../../../content/locales/fr/provider-profile.json';
import reviewsFr from '../../../content/locales/fr/reviews.json';
import tagsFr from '../../../content/locales/fr/tags.json';
import teamFr from '../../../content/locales/fr/team.json';
import timeTrackingFr from '../../../content/locales/fr/time-tracking.json';

type SupportedLocale = 'en' | 'fr';

const translationsByLocale: Record<SupportedLocale, MappedTranslations> = {
  en: {
    alerts: alertsEn,
    'client-tasks': clientTasksEn,
    'document-journey': documentJourneyEn,
    grant_availability: grantAvailabilityEn,
    grant_card_status: grantCardStatusEn,
    project: projectEn,
    propulsion: propulsionEn,
    'program-workspace': programWorkspaceEn,
    resource: resourceEn,
    onboarding: onboardingEn,
    'game-plan-cycles': gamePlanCyclesEn,
    rfp: rfpEn,
    common: commonEn,
    errors: errorsEn,
    reviews: reviewsEn,
    'provider-profile': providerProfileEn,
    profile: profileEn,
    team: teamEn,
    portfolio: portfolioEn,
    tags: tagsEn,
    lang: langEn,
    'confirm-modal': confirmModalEn,
    'project-single': projectSingleEn,
    programs: programsEn,
    grants: grantsEn,
    assets: assetsEn,
    assistant: assistantEn,
    'time-tracking': timeTrackingEn,
    documents: documentsEn,
  } as unknown as MappedTranslations,
  fr: {
    alerts: alertsFr,
    'client-tasks': clientTasksFr,
    'document-journey': documentJourneyFr,
    grant_availability: grantAvailabilityFr,
    grant_card_status: grantCardStatusFr,
    project: projectFr,
    propulsion: propulsionFr,
    'program-workspace': programWorkspaceFr,
    resource: resourceFr,
    onboarding: onboardingFr,
    'game-plan-cycles': gamePlanCyclesFr,
    rfp: rfpFr,
    common: commonFr,
    errors: errorsFr,
    reviews: reviewsFr,
    'provider-profile': providerProfileFr,
    profile: profileFr,
    team: teamFr,
    portfolio: portfolioFr,
    tags: tagsFr,
    lang: langFr,
    'confirm-modal': confirmModalFr,
    'project-single': projectSingleFr,
    programs: programsFr,
    grants: grantsFr,
    assets: assetsFr,
    assistant: assistantFr,
    'time-tracking': timeTrackingFr,
    documents: documentsFr,
  } as unknown as MappedTranslations,
};

export const getLocaleNamespaces = (locale: string): MappedTranslations => {
  if (locale !== 'en' && locale !== 'fr') {
    throw new Error(`Unsupported Client locale: ${locale}`);
  }

  return translationsByLocale[locale];
};
